import { LockOutlined } from "@mui/icons-material";
import {
  Container,
  CssBaseline,
  Box,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../hooks/redux-hooks";
import { login } from "../slices/authSlice";
import React from "react";

const tumBlue = "#0066B1";
const tumBlueDark = "#004C87";

export const Login = () => {
  const dispatch = useAppDispatch();

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async () => {
    if (username && password) {
      try {
        setErrorMessage("");
        await dispatch(login({ username, password })).unwrap();
      } catch (e) {
        setErrorMessage("Benutzername oder Passwort ist falsch.");
        console.error(e);
      }
    } else {
      setErrorMessage("Bitte Benutzername und Passwort eingeben.");
    }
  };

  useEffect(() => {
    const bg =
      "radial-gradient(ellipse at center, #0b0c0f 0%, #1a1a1a 80%), linear-gradient(135deg, #0a132d 0%, #121f4c 100%)";
    const original = {
      bodyBg: document.body.style.background,
      htmlBg: document.documentElement.style.background,
      htmlHeight: document.documentElement.style.height,
      bodyHeight: document.body.style.height,
      fontFamily: document.body.style.fontFamily,
    };

    document.body.style.background = bg;
    document.documentElement.style.background = bg;
    document.body.style.height = "100%";
    document.documentElement.style.height = "100%";
    document.body.style.fontFamily = "'Montserrat', sans-serif";

    return () => {
      document.body.style.background = original.bodyBg;
      document.documentElement.style.background = original.htmlBg;
      document.body.style.height = original.bodyHeight;
      document.documentElement.style.height = original.htmlHeight;
      document.body.style.fontFamily = original.fontFamily;
    };
  }, []);

  return (
    <>
      <CssBaseline />
      <Container
        maxWidth="xs"
        disableGutters
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Vignette Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            zIndex: 1,
            width: "100%",
            px: 3,
            py: 5,
            backdropFilter: "none",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: tumBlue }}>
            <LockOutlined />
          </Avatar>
          <Typography
  variant="h4"
  sx={{
    fontFamily: "'Montserrat', sans-serif",
    color: tumBlue,
    fontWeight: 700,
    fontSize: "2.2rem",
    letterSpacing: "0.11em",
    textTransform: "uppercase",
    mb: 1,
    userSelect: "none",
    position: "relative",
    textShadow: `
      0 0 5px ${tumBlue},
      0 0 10px ${tumBlue},
      0 0 20px ${tumBlueDark},
      0 0 30px ${tumBlueDark}
    `,
    animation: "glowPulse 3s ease-in-out infinite",
  }}
>
  LOGIN
</Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              color: "#aaa",
              fontStyle: "italic",
              textAlign: "center",
              mb: 3,
              textShadow: "0 0 6px rgba(0,0,0,0.7)",
            }}
          >
            Willkommen zurück bei KIminalfall@TUM
          </Typography>

          <Box component="form" noValidate sx={{ width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Benutzername"
              name="username"
              autoFocus
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              InputProps={{ sx: { color: "#eee" } }}
              InputLabelProps={{ sx: { color: "#aaa" } }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: "#444" },
                  '&:hover fieldset': { borderColor: tumBlue },
                  '&.Mui-focused fieldset': { borderColor: tumBlue },
                  fontFamily: "'Montserrat', sans-serif",
                },
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Passwort"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{ sx: { color: "#eee" } }}
              InputLabelProps={{ sx: { color: "#aaa" } }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: "#444" },
                  '&:hover fieldset': { borderColor: tumBlue },
                  '&.Mui-focused fieldset': { borderColor: tumBlue },
                  fontFamily: "'Montserrat', sans-serif",
                },
              }}
            />
            {errorMessage && (
              <Typography
                variant="body2"
                color="error"
                sx={{ mt: 1, fontFamily: "'Montserrat', sans-serif" }}
              >
                {errorMessage}
              </Typography>
            )}
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogin}
              sx={{
                mt: 3,
                mb: 2,
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 700,
                fontSize: "1.1rem",
                padding: "0.9rem 0",
                borderRadius: "9999px",
                backgroundColor: tumBlue,
                color: "#fff",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                boxShadow: `
              0 0 12px ${tumBlue}, 
              0 0 30px ${tumBlue}, 
              0 0 40px ${tumBlueDark}`,
                transition: "all 0.25s ease-in-out",
                "&:hover": {
                  backgroundColor: tumBlueDark,
                  boxShadow: `0 0 20px ${tumBlueDark}, 0 0 40px ${tumBlue}`,
                },
              }}
            >
              Login
            </Button>
            <Grid container justifyContent={"flex-end"}>
              <Grid>
                <Link
                  to="/register"
                  style={{
                    color: tumBlue,
                    fontFamily: "'Montserrat', sans-serif",
                    textDecoration: "underline",
                    fontWeight: 500 
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = tumBlueDark;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = tumBlue;
                  }}
                >
                  Noch keinen Account? Jetzt registrieren
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Login;
